import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Navigate, Outlet, Route, Routes } from 'react-router';

import { INTERNATIONAL_SECTION_ENABLED } from '@/constants/paths';
import Layout from '@/layouts/HeaderLayout/Layout';
import BatchesPage from '@/pages/private/batches';
import Coverage from '@/pages/private/coverage';
import CreateOrderPage from '@/pages/private/create-order/create-order-page';
import CreateInternationalOrder from '@/pages/private/createInternationalOrder';
import EnvioFlexPage from '@/pages/private/envioFlex';
import FalabellaPage from '@/pages/private/falabella';
import Home from '@/pages/private/home';
import InternationalFAQ from '@/pages/private/internationalFAQ';
import InternationalHistory from '@/pages/private/internationalHistory';
import InventoryPage from '@/pages/private/inventory';
import InventoryHistoryPage from '@/pages/private/inventoryHistory';
import MLFulfillPage from '@/pages/private/mlFulfill';
import MLParcelPage from '@/pages/private/mlParcel';
import MyInvoices from '@/pages/private/myInvoices';
import MyPlugins from '@/pages/private/myPlugins';
import MyReports from '@/pages/private/myReports';
import MyShipments from '@/pages/private/myShipments';
import MyUsers from '@/pages/private/myUsers';
import OrderStatusPage from '@/pages/private/orderStatus';
import Pickup from '@/pages/private/pickup';
import Rates from '@/pages/private/rates';
import RechargeBalanceCallback from '@/pages/private/rechargeBalanceCallback';
import Resources from '@/pages/private/resources';
import Support from '@/pages/private/support';
import WarehousesPage from '@/pages/private/warehouses/warehouses-page';
import NotFoundPage from '@/pages/public/notFound';
import { AuthRequired } from '@/providers/auth/auth-required';
import UPSAccessPoint from '@/sections/UPS/upsAccessPoint/UPSAccessPoint';

const MainStyled = styled(Box)(() => ({
  width: '100%',
}));

const GeneralLayout = () => {
  return (
    <Layout>
      <MainStyled>
        <Outlet />
      </MainStyled>
    </Layout>
  );
};

const Router = () => {
  return (
    <Routes>
      {/* Private Routes */}
      <Route
        element={
          <AuthRequired>
            <GeneralLayout />
          </AuthRequired>
        }
      >
        <Route path="/" element={<CreateOrderPage />} />
        <Route path="/statistics" element={<Home />} />
        <Route path="/my-shipments" element={<MyShipments />} />
        <Route path="/pickups" element={<Pickup />} />
        <Route path="/coverage" element={<Coverage />} />
        <Route path="/reports" element={<MyReports />} />
        <Route path="/invoices" element={<MyInvoices />} />
        <Route path="/users" element={<MyUsers />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/rates" element={<Rates />} />
        <Route path="/recharge-balance/callback" element={<RechargeBalanceCallback />} />
        <Route path="/support" element={<Support />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/inventory-history" element={<InventoryHistoryPage />} />
        <Route path="/warehouses" element={<WarehousesPage />} />
        <Route path="/order-status" element={<OrderStatusPage />} />
        <Route path="/batches" element={<BatchesPage />} />
        {/* sección Internacional dada de baja, accesos bloqueados vía flag */}
        <Route
          path="/create-international-order"
          element={
            INTERNATIONAL_SECTION_ENABLED ? (
              <CreateInternationalOrder />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/international-history"
          element={
            INTERNATIONAL_SECTION_ENABLED ? <InternationalHistory /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="/international-support"
          element={
            INTERNATIONAL_SECTION_ENABLED ? <InternationalFAQ /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="/ups-access-point"
          element={INTERNATIONAL_SECTION_ENABLED ? <UPSAccessPoint /> : <Navigate to="/" replace />}
        />
        {/* Rutas de plugins */}
        <Route path="/my-plugins" element={<MyPlugins />} />
        <Route path="/envio-flex" element={<EnvioFlexPage />} />
        <Route path="/ml-fulfill" element={<MLFulfillPage />} />
        <Route path="/ml-parcel" element={<MLParcelPage />} />
        <Route path="/falabella" element={<FalabellaPage />} />
      </Route>

      {/* Catch-all route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Router;
